interface StatusBadgeProps {
  status: string;
}

const statusMap: Record<string, { label: string; className: string; dotClassName: string }> = {
  PENDING: {
    label: 'Aguardando',
    className: 'border-slate-200 bg-slate-100 text-slate-700',
    dotClassName: 'bg-slate-400'
  },
  RUNNING: {
    label: 'Executando',
    className: 'border-sky-200 bg-sky-50 text-sky-700',
    dotClassName: 'bg-sky-500'
  },
  COMPLETED: {
    label: 'Concluída',
    className: 'border-emerald-200 bg-emerald-50 text-emerald-700',
    dotClassName: 'bg-emerald-500'
  },
  PAUSED: {
    label: 'Pausada',
    className: 'border-amber-200 bg-amber-50 text-amber-700',
    dotClassName: 'bg-amber-500'
  },
  FAILED: {
    label: 'Falha',
    className: 'border-rose-200 bg-rose-50 text-rose-700',
    dotClassName: 'bg-rose-500'
  }
};

export function StatusBadge({ status }: StatusBadgeProps) {
  const config = statusMap[status] || statusMap.PENDING;

  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full border px-2.5 py-1 text-xs font-semibold ${config.className}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${config.dotClassName}`} />
      {config.label}
    </span>
  );
}
